import { render, staticRenderFns } from "./StudentGroupDetail.vue?vue&type=template&id=b8e93f06&scoped=true"
import script from "./StudentGroupDetail.vue?vue&type=script&lang=js"
export * from "./StudentGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentGroupDetail.vue?vue&type=style&index=0&id=b8e93f06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e93f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e93f06')) {
      api.createRecord('b8e93f06', component.options)
    } else {
      api.reload('b8e93f06', component.options)
    }
    module.hot.accept("./StudentGroupDetail.vue?vue&type=template&id=b8e93f06&scoped=true", function () {
      api.rerender('b8e93f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/ViewStudentGroup/StudentGroupDetail.vue"
export default component.exports